import React from 'react';
import cx from 'classnames';

const BusinessProfilesTimeline = ({
  type,
  step,
}) => {
  const actionLabel = type === 'create' ? 'Create' : 'Edit';
  const step1Classes = cx({
    'col-xs-5': true,
    'padding-right-0': true,
    'timeline-segment': true,
    'timeline-segment-1': true,
    'active': true,
  });

  const step2Classes = cx({
    'col-xs-5': true,
    'padding-left-0': true,
    'timeline-segment': true,
    'timeline-segment-2': true,
    'timeline-segment-last': true,
    'active': (step >= 2),
  });

  const step2TextClasses = cx({
    'h5-sg': true,
    'text-weight-book': true,
    'without-vertical-margin': true,
    'line-height-double': true,
    'vertical-padding-top': true,
    'text-color-dark-slate': (step >= 2),
    'text-color-light-grey': (step < 2),
  });

  const step2HeaderClasses = cx({
    'col-xs-6': true,
    'padding-left-0': true,
    'text-color-light-grey': (step < 2),
  });

  return (
    <div>
      <div className="row timeline">
        <div className={step1Classes}>
          <hr />
        </div>
        <div className={step2Classes}>
          <hr />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-5">
          <h5 className="h5-sg text-weight-book text-color-dark-slate without-vertical-margin line-height-double vertical-padding-top">{`${actionLabel} Business Profile`}</h5>
          <p className="text-weight-book">Track your business expenses separately</p>
        </div>
        <div className={step2HeaderClasses}>
          <h5 className={step2TextClasses}>Expense Business Payments</h5>
          <p className="text-weight-book">Link your business payments</p>
        </div>
      </div>
    </div>
  );
};

export default BusinessProfilesTimeline;
